import Api from "../../../app/apiRequest";
import BaseResponse from "../../../app/BaseResponse";
import ClassificationModel from "../../Classification/models/ClassificationModel";
import CareModel from "../models/CareModel";
import CareQueryModel from "../models/CareQueryModel";

export interface SearchCareParam {
    pageSize: number,
    query: CareQueryModel
}

export interface GetCareByIdParam {
    careId: string,
    clientId: string,
    year: number,
}

export interface DeleteCareByIdParam {
    id: string,
}

export interface GetClassificationsParam {
    searchDate: string,
}

export interface SplitCompanyParam {
    clientId: string,
    year: number,
}

const CareApi = {
    Search(param: SearchCareParam) {
        return Api.post<SearchCareParam, BaseResponse<CareModel[]>>("/api/Care/Search", param);
    },
    Save(param: CareModel) {
        return Api.post<CareModel, BaseResponse<CareModel>>("/api/Care/Save", param);
    },
    GetById(param: GetCareByIdParam) {
        return Api.get<GetCareByIdParam, BaseResponse<CareModel>>("/api/Care/GetById", param);
    },
    Delete(param: DeleteCareByIdParam) {
        return Api.post<DeleteCareByIdParam, BaseResponse<CareModel>>("/api/Care/Delete", param);
    },
    GetClassifications(param: GetClassificationsParam) {
        return Api.post<GetClassificationsParam, BaseResponse<ClassificationModel[]>>("/api/Care/GetClassifications", param);
    },
    SplitCompany(param: SplitCompanyParam) {
        return Api.post<SplitCompanyParam, BaseResponse<string>>("/api/Care/SplitCompany", param);
    },
};
export default CareApi;